const buildWebStorageApiStrategy = (store) => () => {
  const load = ({ key }) => {
    const stored = store.getItem(key);
    return stored === null ? undefined : stored;
  };
  const save = ({ key, value }) => store.setItem(key, value);
  const remove = ({ key }) => store.removeItem(key);
  const getConfig = () => ({
    isExpirySupported: false,
  });

  return { load, save, remove, getConfig };
};

export const localStorageStrategy = buildWebStorageApiStrategy(window.localStorage);

export const sessionStorageStrategy = buildWebStorageApiStrategy(window.sessionStorage);

const windowCookies = {
  get: () => document.cookie,
  set: (cookie) => { document.cookie = cookie; },
};

const _windowLocation = {
  getLocation: () => location,
};

export const cookieStorageStrategy = (cookies = windowCookies, windowLocation = _windowLocation) => {
  /* Being that location.hostname may return either a fully qualified
   * domain name (i.e., <subdomain>.<2nd-level-domain>.<tld>) or an
   * IP address, this function will ensure that you either get the IP address
   * or a domain that includes only the 2nd-level-domain and the tld.
   */
  const getCookieDomain = () => {
    const { hostname } = windowLocation.getLocation();

    // Test for IP address
    const octets = hostname.split('.');
    if (octets.length === 4 &&
      octets.every((octet) => parseInt(octet, 10) <= 255)) {
      return hostname;
    }

    // Most be a domain name.  Only return the TLD and the 2LD.
    return hostname.split('.').splice(-2).join('.');
  };

  const load = ({ key }) => {
    const value = `; ${cookies.get()}`;
    const parts = value.split(`; ${key}=`);
    return parts.length === 2
      ? parts.pop().split(';').shift()
      : undefined;
  };

  const domain = getCookieDomain();
  if (!domain) {
    throw new Error('Couldn\'t retreive domain');
  }

  const save = ({ key, value, expiry }) => {
    let segments = [
      `${key}=${value};`,
      `domain=${domain};`,
      'path=/;',
    ];
    if (expiry) {
      segments = [...segments, `expires=${expiry.toGMTString()}`];
    }
    cookies.set(segments.join(' '));
  };

  const remove = ({ key }) => {
    cookies.set(`${key}=; domain=${domain}; path=/; expires=Thu, 01 Jan 1970 00:00:01 GMT;`);
  };

  const getConfig = () => ({
    isExpirySupported: true,
  });

  return { load, save, remove, getConfig };
};
